<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 21V9h2v2h2V3h2v2h2V3h2v2h2V3h2v2h2V3h2v8h2V9h2v12h-9v-3c0-.55-.196-1.02-.588-1.413A1.926 1.926 0 0 0 12 16c-.55 0-1.02.196-1.412.587A1.926 1.926 0 0 0 10 18v3H1Zm2-2h5v-1c0-1.1.392-2.042 1.175-2.825C9.958 14.392 10.9 14 12 14s2.042.392 2.825 1.175C15.608 15.958 16 16.9 16 18v1h5v-6h-4V7H7v6H3v6Zm6-7h2V9H9v3Zm4 0h2V9h-2v3Z"
    />
  </svg>
</template>
